import Swal from 'sweetalert2';
import { msg } from 'src/app/constants/msg';
import * as i0 from "@angular/core";
export class AlertService {
    constructor() { }
    showSuccess(text) {
        return Swal.fire({
            heightAuto: false,
            text: text,
            icon: 'success',
            customClass: {
                confirmButton: 'swal-confirm-btn',
            },
            showClass: {
                popup: 'animate__animated animate__fadeIn animate__faster'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOut animate__faster'
            }
        });
    }
    showError(text) {
        return Swal.fire({
            heightAuto: false,
            text: text,
            icon: 'error',
            customClass: {
                confirmButton: 'swal-confirm-btn',
            },
            showClass: {
                popup: 'animate__animated animate__fadeIn animate__faster'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOut animate__faster'
            }
        });
    }
    showInfo(title, message) {
        return Swal.fire({
            confirmButtonColor: '#fbaf47',
            heightAuto: false,
            title: title,
            text: message,
            customClass: {
                confirmButton: 'swal-confirm-btn',
                cancelButton: 'swal-cancel-btn'
            },
            showClass: {
                popup: 'animate__animated animate__fadeIn animate__faster'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOut animate__faster'
            }
        });
    }
    showDiscardChanges(title, message) {
        return Swal.fire({
            heightAuto: false,
            title: title ? title : msg.discardChanges.title,
            text: message ? message : msg.discardChanges.text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: msg.discardChanges.confirmButtonText,
            cancelButtonText: msg.discardChanges.cancelButtonText,
            customClass: {
                confirmButton: 'swal-confirm-btn',
                cancelButton: 'swal-cancel-btn',
            },
            showClass: {
                popup: 'animate__animated animate__fadeIn animate__faster'
            },
            hideClass: {
                popup: 'animate__animated animate__fadeOut animate__faster'
            }
        });
    }
}
AlertService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AlertService_Factory() { return new AlertService(); }, token: AlertService, providedIn: "root" });
